<template>
  <v-navigation-drawer
    width="35vw"
    style="z-index: 12 !important"
    right
    absolute
    app
    temporary
    v-model="showAnnouncementDrawer"
  >
    <v-card flat>
      <v-card-title>
        <span class="primary--text pa-1" v-if="!selectedAnnouncement"
          >Announcements</span
        >
        <div v-else class="d-flex align-center">
          <v-btn fab small text @click="selectedAnnouncement = null">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <span class="primary--text">{{ selectedAnnouncement.title }}</span>
        </div>
        <v-spacer />
        <v-btn icon @click="showAnnouncementDrawer = false">
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-row no-gutters v-if="!selectedAnnouncement">
          <v-col
            cols="12"
            v-for="(announcement, index) in announcementList"
            :key="index"
            class="pb-2"
          >
            <v-card
              max-height="120px"
              outlined
              style="overflow: hidden"
              elevation="1"
              @click="selectedAnnouncement = announcement"
            >
              <v-card-title class="pa-2 d-flex align-center">
                <span class="primary--text">{{ announcement.title }}</span>
                <v-spacer />
                <span class="text-caption">
                  Posted on {{ announcement.start_date }}
                  <v-icon>mdi-chevron-right</v-icon>
                </span>
              </v-card-title>
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex align-center justify-center" v-if="announcementList.length <= 0">
            <span>No Announcements at the moment.</span>
          </v-col>
        </v-row>
        <div v-else>
          <span v-html="selectedAnnouncement.description" />
        </div>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAnnouncementDrawer: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      announcementList: [],
      selectedAnnouncement: null,
    };
  },
  methods: {
    getAnnouncementList() {
      this.$api.announcement
        .getAnnouncementList()
        .then((res) => {
          this.announcementList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getAnnouncementList();
  },
};
</script>

<style></style>
